import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Navbar from '../../Pages/Navbar/JobSeekerNavbar';
import BaseUrl from '../../ApiServices/BaseUrl';
import Footer from '../../Footer/Footer';
import './AppliedJobs.css';

function AppliedJobs() {
    const navigate = useNavigate();
    const user = JSON.parse(localStorage.getItem('user')) || {};
    const [jobs, setJobs] = useState([]);
    const [filteredJobs, setFilteredJobs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [jobApplicationStatus, setJobApplicationStatus] = useState({});

    // Initial filter state
    const initialFilters = {
        location: [],
        position: '',
        startDate: '',
        jobType: '',
        contractStatus: [],
        postBy: '',
        language: [],
        skills: [],
        status: []
    };

    // Filter states
    const [activeFilters, setActiveFilters] = useState(initialFilters);

    // Handle window resize for responsive behavior
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [showFiltersMobile, setShowFiltersMobile] = useState(false);
    // Toggle states for filter sections - initialize based on screen size
    const [showLocation, setShowLocation] = useState(!isMobile);
    const [showPosition, setShowPosition] = useState(!isMobile);
    const [showStartDate, setShowStartDate] = useState(!isMobile);
    const [showJobType, setShowJobType] = useState(!isMobile);
    const [showContractStatus, setShowContractStatus] = useState(!isMobile);
    const [showPostBy, setShowPostBy] = useState(!isMobile);
    const [showLanguage, setShowLanguage] = useState(!isMobile);
    const [showSkills, setShowSkills] = useState(!isMobile);
    const [showStatus, setShowStatus] = useState(!isMobile);

    // States for showing more items
    const [showAllLocations, setShowAllLocations] = useState(false);
    const [showAllJobTypes, setShowAllJobTypes] = useState(false);
    const [showAllContractStatuses, setShowAllContractStatuses] = useState(false);
    const [showAllLanguages, setShowAllLanguages] = useState(false);
    const [showAllSkills, setShowAllSkills] = useState(false);
    const [showAllPositions, setShowAllPositions] = useState(false);

    // Data for filters
    const jobLocations = [
        { id: 'hong-kong', name: 'Hong Kong', icon: 'https://cdn.helperplace.com/country/hong-kong.svg' },
        { id: 'singapore', name: 'Singapore', icon: 'https://cdn.helperplace.com/country/singapore.svg' },
        { id: 'macau', name: 'Macau', icon: 'https://cdn.helperplace.com/country/macau.svg' },
        { id: 'saudi-arabia', name: 'Saudi Arabia', icon: 'https://cdn.helperplace.com/country/saudi-arabia.svg' },
        { id: 'qatar', name: 'Qatar', icon: 'https://cdn.helperplace.com/country/qatar.svg' },
        { id: 'dubai', name: 'Dubai', icon: 'https://cdn.helperplace.com/country/united-arab-emirates.svg' },
        { id: 'malaysia', name: 'Malaysia', icon: 'https://cdn.helperplace.com/country/malaysia.svg' },
        { id: 'taiwan', name: 'Taiwan', icon: 'https://cdn.helperplace.com/country/taiwan.svg' },
        { id: 'kuwait', name: 'Kuwait', icon: 'https://cdn.helperplace.com/country/kuwait.svg' },
        { id: 'oman', name: 'Oman', icon: 'https://cdn.helperplace.com/country/oman.svg' },
        { id: 'Bahrain', name: 'Bahrain', icon: 'https://cdn.helperplace.com/country/oman.svg' },
        { id: 'Italy', name: 'Italy', icon: 'https://cdn.helperplace.com/country/oman.svg' },
    ];

    const jobPositions = [
        { id: 'maid', name: 'Maid', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
        { id: 'driver', name: 'Driver', icon: 'https://cdn.helperplace.com/icons/driver.svg' },
        { id: 'cook', name: 'Cook', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
        { id: 'nanny', name: 'Nanny', icon: 'https://cdn.helperplace.com/icons/nanny.svg' },
        { id: 'nurse', name: 'Nurse', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
        { id: 'houseboy', name: 'Houseboy', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
        { id: 'tailor', name: 'Tailor', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
        { id: 'teacher', name: 'Teacher', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
        { id: 'trainer', name: 'Trainer', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
        { id: 'gardener', name: 'Gardener', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
        { id: 'butler', name: 'Butler', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
        { id: 'housekeeper', name: 'Housekeeper', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
        { id: 'laundry-worker', name: 'Laundry Worker', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
        { id: 'personal-assistant', name: 'Personal Assistant', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
        { id: 'caregiver', name: 'Caregiver', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
        { id: 'elder-care-companion', name: 'Elder Care Companion', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
        { id: 'pet-sitter', name: 'Pet Sitter/Dog Walker', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
        { id: 'house-manager', name: 'House Manager', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
        { id: 'cleaner', name: 'Cleaner', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
        { id: 'maintenance-worker', name: 'Maintenance Worker/Handyman', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
        { id: 'baby-sitter', name: 'Baby Sitter', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
        { id: 'tutor', name: 'Tutor', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
        { id: 'chauffeur', name: 'Chauffeur', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
        { id: 'housemaid', name: 'Housemaid', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
        { id: 'kitchen-staff', name: 'Kitchen Staff', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
        { id: 'dining-room-attendant', name: 'Dining Room Attendant', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
        { id: 'personal-chef', name: 'Personal Chef', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
        { id: 'event-coordinator', name: 'Event Coordinator', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
        { id: 'household-administrator', name: 'Household Administrator', icon: 'https://cdn.helperplace.com/icons/maid.svg' },
        { id: 'domestic-assistant', name: 'Domestic Assistant', icon: 'https://cdn.helperplace.com/icons/maid.svg' }
    ];

    const jobTypes = [
        { id: 'full time', name: 'Full Time', icon: 'https://cdn.helperplace.com/icons/clock.svg' },
        { id: 'part time', name: 'Part Time', icon: 'https://cdn.helperplace.com/icons/time-mgmt.svg' },
        { id: 'temporary', name: 'Temporary', icon: 'https://cdn.helperplace.com/icons/signs.svg' },
        { id: 'permanent', name: 'Permanent', icon: 'https://cdn.helperplace.com/icons/clock.svg' },
        { id: 'internship', name: 'Internship', icon: 'https://cdn.helperplace.com/icons/time-mgmt.svg' },
        { id: 'contractual', name: 'Contractual', icon: 'https://cdn.helperplace.com/icons/clock.svg' },
        { id: 'freelancer', name: 'Freelancer', icon: 'https://cdn.helperplace.com/icons/signs.svg' },
        { id: 'volunteer', name: 'Volunteer', icon: 'https://cdn.helperplace.com/icons/clock.svg' },
        { id: 'fresher', name: 'Fresher', icon: 'https://cdn.helperplace.com/icons/time-mgmt.svg' },
    ];

    const contractStatuses = [
        { id: 'any', name: 'Any' },
        { id: 'contract', name: 'Finshed Contract' },
        { id: 'terminated', name: 'Terminated' },
        { id: 'break contract', name: 'Break Contract' },
        { id: 'transfer', name: 'Transfer' },
        { id: 'Any overseas experience', name: 'Any Overseas Experience' },
        { id: 'resigned', name: 'Resigned' },
    ];

    const postByOptions = [
        { id: 'direct', name: 'Direct' },
        { id: 'agency', name: 'Agency' }
    ];

    const languages = [
        { id: 'english', name: 'English' },
        { id: 'cantonese', name: 'Cantonese' },
        { id: 'mandarin', name: 'Mandarin' },
        { id: 'arabic', name: 'Arabic' },
        { id: 'hindi', name: 'Hindi' },
        { id: 'tagalog', name: 'Tagalog' },
        { id: 'malayali', name: 'Malayali' },
        { id: 'tamil', name: 'Tamil' },
        { id: 'nepali', name: 'Nepali' },
        { id: 'srilankan', name: 'Sri Lankan' },
        { id: 'japanese', name: 'Japanese' },
        { id: 'russian', name: 'Russian' },
        { id: 'bangali', name: 'Bengali' },
        { id: 'vietnamese', name: 'Vietnamese' },
        { id: 'combodian', name: 'Khmer' },
        { id: 'iranian', name: 'Persian' },
        { id: 'korean', name: 'Korean' }
    ];

    const mainSkills = [
        { id: 'babycare', name: 'Baby Care' },
        { id: 'childcare', name: 'Child Care' },
        { id: 'teencare', name: 'Teen Care' },
        { id: 'elderly-care', name: 'Elderly Care' },
        { id: 'pet-care', name: 'Pet Care' },
        { id: 'tutoring', name: 'Tutoring' },
        { id: 'cooking', name: 'Cooking' },
        { id: 'house-keeping', name: 'House-Keeping' },
        { id: 'cleaning', name: 'Cleaning' },
        { id: 'marketing', name: 'Marketing' },
        { id: 'grocerias', name: 'Grocerias' }
    ];

    const statusOptions = [
        { id: 'Applied', name: 'Applied' },
        { id: 'Shortlisted', name: 'Shortlisted' },
        { id: 'Rejected', name: 'Rejected' }
    ];

    // Handle window resize
    useEffect(() => {
        const handleResize = () => {
            const mobile = window.innerWidth < 768;
            setIsMobile(mobile);

            // If switching to mobile, close all filters
            if (mobile) {
                setShowLocation(false);
                setShowPosition(false);
                setShowStartDate(false);
                setShowJobType(false);
                setShowContractStatus(false);
                setShowPostBy(false);
                setShowLanguage(false);
                setShowSkills(false);
                setShowStatus(false);
            } else {
                // If switching to desktop, open all filters
                setShowLocation(true);
                setShowPosition(true);
                setShowStartDate(true);
                setShowJobType(true);
                setShowContractStatus(true);
                setShowPostBy(true);
                setShowLanguage(true);
                setShowSkills(true);
                setShowStatus(true);
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const toggleFilter = (filterType, id) => {
        setActiveFilters((prev) => {
            const currentValues = prev[filterType] || [];
            const newValues = currentValues.includes(id)
                ? currentValues.filter((item) => item !== id)
                : [...currentValues, id];
            return { ...prev, [filterType]: newValues };
        });
    };

    const toggleRadioFilter = (filterType, id) => {
        setActiveFilters((prev) => ({
            ...prev,
            [filterType]: prev[filterType] === id ? '' : id
        }));
    };

    const handleJobClick = (job) => {
        navigate('/appliedjobdetails', { state: { job } });
    };
const formatDate = (dateString) => {
    if (!dateString || dateString === '0000-00-00' || dateString === '0000-00-00 00:00:00') {
        return 'N/A';
    }

    try {
        // Try to parse the date string
        let date;
        
        // Check if it's already a Date object
        if (dateString instanceof Date) {
            date = dateString;
        } 
        // Check common date formats
        else if (typeof dateString === 'string') {
            // Remove any timezone info and trim whitespace
            dateString = dateString.trim();
            
            // Handle ISO format (with or without time)
            if (dateString.includes('T')) {
                date = new Date(dateString);
            }
            // Handle YYYY-MM-DD format
            else if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
                date = new Date(dateString + 'T00:00:00');
            }
            // Handle YYYY-MM-DD HH:MM:SS format
            else if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(dateString)) {
                date = new Date(dateString.replace(' ', 'T'));
            }
            // Try direct parsing as a fallback
            else {
                date = new Date(dateString);
            }
        } else {
            return 'N/A';
        }

        // Check if the date is valid
        if (isNaN(date.getTime())) {
            return 'N/A';
        }

        // Format the date
        return date.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        });
    } catch (e) {
        console.error('Error formatting date:', dateString, e);
        return 'N/A';
    }
};

    const safeParseArray = (field) => {
        if (!field) return [];
        if (Array.isArray(field)) return field;
        if (typeof field === 'string') {
            try {
                const parsed = JSON.parse(field.replace(/\\"/g, '"'));
                return Array.isArray(parsed) ? parsed : [];
            } catch {
                return [];
            }
        }
        return [];
    };

    const getStatusBadgeStyle = (status) => {
        switch (status) {
            case 'Applied':
                return 'warning';
            case 'Shortlisted':
                return 'success';
            case 'Rejected':
                return 'danger';
            default:
                return 'secondary';
        }
    };

    const resetAllFilters = () => {
        setActiveFilters(initialFilters);
        setShowAllLocations(false);
        setShowAllJobTypes(false);
        setShowAllContractStatuses(false);
        setShowAllLanguages(false);
        setShowAllSkills(false);
        setShowAllPositions(false);
    };

    useEffect(() => {
        const fetchJobsAndApplications = async () => {
            try {
                // Fetch Jobs
                const jobsResponse = await fetch(`${BaseUrl}/api/employer/all`);
                if (!jobsResponse.ok) {
                    throw new Error('Failed to fetch jobs');
                }
                let jobsData = await jobsResponse.json();

                // Process job arrays
                jobsData = jobsData.map(job => ({
                    ...job,
                    preferred_candidates_country: safeParseArray(job.preferred_candidates_country),
                    candidates_country_experience: safeParseArray(job.candidates_country_experience),
                    main_skills: safeParseArray(job.main_skills),
                    cooking_skills: safeParseArray(job.cooking_skills),
                    other_skills: safeParseArray(job.other_skills),
                    preferred_years_of_experience: safeParseArray(job.preferred_years_of_experience),
                    offer_for_selected_candidates: safeParseArray(job.offer_for_selected_candidates),
                    preferred_language_for_worker: safeParseArray(job.preferred_language_for_worker),
                    profile_photo_url: job.profile_photo
                        ? `${BaseUrl}${job.profile_photo}`
                        : null
                }));

                // Fetch Applications
                const appsResponse = await fetch(`${BaseUrl}/api/applications`);
                if (!appsResponse.ok) {
                    throw new Error('Failed to fetch applications');
                }
                const applications = await appsResponse.json();

                // Filter applications where userid matches user.id
                const userApplications = applications.filter(app => app.userid === user.id);

                // Create a map of jobid to status
                const statusMap = {};
                userApplications.forEach(app => {
                    if (app.jobid) {
                        statusMap[app.jobid] = app.status || 'Applied';
                    }
                });

                // Filter jobs that match the user's applications
                const filteredJobs = jobsData.filter(job => job.id && statusMap[job.id]);

                // Set states
                setJobs(jobsData);
                setFilteredJobs(filteredJobs);
                setJobApplicationStatus(statusMap);

            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchJobsAndApplications();
    }, [user.id]);

    useEffect(() => {
        let result = [...jobs];

        // First filter only jobs that have been applied to
        result = result.filter(job => job.id && jobApplicationStatus[job.id]);

        // Filter by job position
        if (activeFilters.position) {
            result = result.filter(job => {
                const category = job.domestic_worker_category?.toLowerCase().replace(/\s+/g, '-');
                return category?.includes(activeFilters.position);
            });
        }

        // Filter by location
        if (activeFilters.location.length > 0) {
            result = result.filter(job => {
                const preferredLocations = job.preferred_candidates_country?.map(loc => loc.toLowerCase()) || [];
                return activeFilters.location.some(locationId => {
                    const location = jobLocations.find(loc => loc.id === locationId);
                    if (!location) return false;

                    return preferredLocations.includes(location.name.toLowerCase()) ||
                        job.working_city?.toLowerCase().includes(location.name.toLowerCase()) ||
                        job.state_or_province?.toLowerCase().includes(location.name.toLowerCase());
                });
            });
        }

        // Filter by job type
        if (activeFilters.jobType) {
            result = result.filter(job => {
                const type = job.job_type?.toLowerCase();
                return type?.includes(activeFilters.jobType.toLowerCase());
            });
        }

        // Filter by contract status
        if (activeFilters.contractStatus.length > 0) {
            result = result.filter(job => {
                const status = job.contract_status?.toLowerCase();
                return activeFilters.contractStatus.some(contractStatus =>
                    status?.includes(contractStatus)
                );
            });
        }

        // Filter by posted by
        if (activeFilters.postBy) {
            result = result.filter(job => {
                const type = job.posted_by?.toLowerCase();
                return type?.includes(activeFilters.postBy.toLowerCase());
            });
        }

        // Filter by language
        if (activeFilters.language.length > 0) {
            result = result.filter(job => {
                const jobLanguages = Array.isArray(job.preferred_language_for_worker)
                    ? job.preferred_language_for_worker.map(lang => lang?.toString().toLowerCase())
                    : [];

                return activeFilters.language.some(langId => {
                    const languageObj = languages.find(l => l.id === langId);
                    const languageName = languageObj?.name?.toLowerCase();
                    return languageName && jobLanguages.some(jobLang => jobLang.includes(languageName));
                });
            });
        }

        // Filter by main skills
        if (activeFilters.skills.length > 0) {
            result = result.filter(job => {
                const skills = job.main_skills?.join(' ').toLowerCase() || '';
                return activeFilters.skills.some(skillId => {
                    const skill = mainSkills.find(s => s.id === skillId);
                    return skill && skills.includes(skill.name.toLowerCase());
                });
            });
        }

        // Filter by status
        if (activeFilters.status.length > 0) {
            result = result.filter(job => {
                const status = jobApplicationStatus[job.id] || 'Applied';
                return activeFilters.status.includes(status);
            });
        }

        // Filter by start date
       // Filter by start date
if (activeFilters.startDate) {
    try {
        const selectedDate = new Date(activeFilters.startDate);
        
        // Check if selected date is valid
        if (isNaN(selectedDate.getTime())) {
            throw new Error('Invalid selected date');
        }
        
        selectedDate.setHours(0, 0, 0, 0);

        result = result.filter(job => {
            if (!job.job_starting_date) return false;

            try {
                const jobDate = new Date(job.job_starting_date);
                
                // Check if job date is valid
                if (isNaN(jobDate.getTime())) {
                    return false;
                }
                
                jobDate.setHours(0, 0, 0, 0);
                return jobDate >= selectedDate;
            } catch (e) {
                console.error('Error parsing job date:', job.job_starting_date, e);
                return false;
            }
        });
    } catch (e) {
        console.error('Error parsing selected date:', activeFilters.startDate, e);
    }
}

        setFilteredJobs(result);
    }, [jobs, activeFilters, jobApplicationStatus]);

    if (loading) {
        return (
            <>
                <Navbar />
                <div className="container-fluid joblisting-wrapper py-4">
                    <div className="text-center">Loading jobs...</div>
                </div>
            </>
        );
    }

    if (error) {
        return (
            <>
                <Navbar />
                <div className="container-fluid joblisting-wrapper py-4">
                    <div className="text-center text-danger">Error: {error}</div>
                </div>
            </>
        );
    }

    return (
        <>
            <Navbar />
            <div className="container-fluid joblisting-wrapper py-4" style={{ marginTop: '80px' }}>
                <div className="row">
                    {/* Sidebar Filter */}
                    {isMobile && (
                        <div className="mb-3">
                            <button
                                className="btn btn-primary w-100"
                                onClick={() => setShowFiltersMobile(!showFiltersMobile)}
                            >
                                <i className={`bi ${showFiltersMobile ? 'bi-chevron-up' : 'bi-chevron-down'} me-2`}></i>
                                {showFiltersMobile ? 'Hide Filters' : 'Show Filters'}
                            </button>
                        </div>
                    )}
                    <div className="col-md-3">
                        {(showFiltersMobile || !isMobile) && (
                            <div className="filters p-3 mb-2 border rounded bg-light">
                                {/* Filter Header with Refresh Button */}
                                <div className="d-flex justify-content-between align-items-center mb-4">
                                    <h5 className="mb-0">Filters</h5>
                                    <button
                                        className="btn btn-sm btn-outline-secondary"
                                        onClick={resetAllFilters}
                                        title="Reset all filters"
                                    >
                                        <i className="bi bi-arrow-clockwise"></i> Reset
                                    </button>
                                </div>
                                {/* Header Text */}
                                <div className="mb-4 text-center">
                                    <p className="fw-bold fs-6 text-dark">
                                        Your Applied Jobs
                                    </p>
                                    <div className="d-flex justify-content-center gap-2 mt-2">
                                        <span className="badge rounded-pill bg-light text-dark d-flex align-items-center px-3 py-2 shadow-sm">
                                            <i className="bi bi-check-circle me-2"></i>
                                            Applied Jobs
                                        </span>
                                    </div>
                                </div>

                                {/* Status Filter */}
                                <div className="mb-4 filter-section">
                                    <div
                                        className="d-flex justify-content-between align-items-center cursor-pointer mb-2 filter-header"
                                        onClick={() => setShowStatus(!showStatus)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <strong>Application Status</strong>
                                        <i className={`bi ${showStatus ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showStatus && (
                                        <div className="filter-content">
                                            <div className="d-flex flex-column gap-2">
                                                {statusOptions.map((status) => (
                                                    <div key={status.id} className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            id={`status-${status.id}`}
                                                            checked={activeFilters.status.includes(status.id)}
                                                            onChange={() => toggleFilter('status', status.id)}
                                                        />
                                                        <label className="form-check-label" htmlFor={`status-${status.id}`}>
                                                            {status.name}
                                                        </label>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {/* Location Filter */}
                                <div className="mb-2 filter-section">
                                    <div
                                        className="d-flex justify-content-between align-items-center cursor-pointer mb-2 filter-header"
                                        onClick={() => setShowLocation(!showLocation)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <strong>Job Location</strong>
                                        <i className={`bi ${showLocation ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showLocation && (
                                        <div className="filter-content">
                                            <div className="d-flex flex-column gap-2">
                                                {jobLocations.slice(0, showAllLocations ? jobLocations.length : 5).map((loc) => (
                                                    <div key={loc.id} className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            id={`location-${loc.id}`}
                                                            checked={activeFilters.location.includes(loc.id)}
                                                            onChange={() => toggleFilter('location', loc.id)}
                                                        />
                                                        <label className="form-check-label d-flex align-items-center" htmlFor={`location-${loc.id}`}>
                                                            {loc.icon && <img src={loc.icon} alt={loc.name} width="20" height="20" className="me-2" />}
                                                            {loc.name}
                                                        </label>
                                                    </div>
                                                ))}
                                                {jobLocations.length > 5 && (
                                                    <button
                                                        className="btn btn-link p-0 text-decoration-none text-primary" style={{ textAlign: 'left' }}
                                                        onClick={() => setShowAllLocations(!showAllLocations)}
                                                    >
                                                        {showAllLocations ? 'Show Less' : 'Show More'}
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {/* Job Position Filter */}
                                <div className="mb-4 filter-section">
                                    <div
                                        className="d-flex justify-content-between align-items-center cursor-pointer mb-2 filter-header"
                                        onClick={() => setShowPosition(!showPosition)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <strong>Job Position</strong>
                                        <i className={`bi ${showPosition ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showPosition && (
                                        <div className="filter-content">
                                            <div className="d-flex flex-column gap-2">
                                                {jobPositions.slice(0, showAllPositions ? jobPositions.length : 5).map((pos) => (
                                                    <div key={pos.id} className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="jobPosition"
                                                            id={`position-${pos.id}`}
                                                            checked={activeFilters.position === pos.id}
                                                            onChange={() => toggleRadioFilter('position', pos.id)}
                                                        />
                                                        <label className="form-check-label d-flex align-items-center" htmlFor={`position-${pos.id}`}>
                                                            {pos.icon && <img src={pos.icon} alt={pos.name} width="20" height="20" className="me-2" />}
                                                            {pos.name}
                                                        </label>
                                                    </div>
                                                ))}
                                                {jobPositions.length > 5 && (
                                                    <button
                                                        className="btn btn-link p-0 text-decoration-none text-primary" style={{ textAlign: 'left' }}
                                                        onClick={() => setShowAllPositions(!showAllPositions)}
                                                    >
                                                        {showAllPositions ? 'Show Less' : 'Show More'}
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {/* Start Date Filter */}
                                <div className="mb-4 filter-section">
                                    <div
                                        className="d-flex justify-content-between align-items-center cursor-pointer mb-2 filter-header"
                                        onClick={() => setShowStartDate(!showStartDate)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <strong>Start Date</strong>
                                        <i className={`bi ${showStartDate ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showStartDate && (
                                        <div className="filter-content">
                                            <div className="p-2 bg-white rounded border">
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    value={activeFilters.startDate}
                                                    onChange={(e) => setActiveFilters({ ...activeFilters, startDate: e.target.value })}
                                                />
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {/* Job Type Filter */}
                                <div className="mb-4 filter-section">
                                    <div
                                        className="d-flex justify-content-between align-items-center cursor-pointer mb-2 filter-header"
                                        onClick={() => setShowJobType(!showJobType)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <strong>Job Type</strong>
                                        <i className={`bi ${showJobType ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showJobType && (
                                        <div className="filter-content">
                                            <div className="d-flex flex-column gap-2">
                                                {jobTypes.slice(0, showAllJobTypes ? jobTypes.length : 5).map((type) => (
                                                    <div key={type.id} className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="jobType"
                                                            id={`type-${type.id}`}
                                                            checked={activeFilters.jobType === type.id}
                                                            onChange={() => toggleRadioFilter('jobType', type.id)}
                                                        />
                                                        <label className="form-check-label d-flex align-items-center" htmlFor={`type-${type.id}`}>
                                                            {type.icon && <img src={type.icon} alt={type.name} width="20" height="20" className="me-2" />}
                                                            {type.name}
                                                        </label>
                                                    </div>
                                                ))}
                                                {jobTypes.length > 5 && (
                                                    <button
                                                        className="btn btn-link p-0 text-decoration-none text-primary" style={{ textAlign: 'left' }}
                                                        onClick={() => setShowAllJobTypes(!showAllJobTypes)}
                                                    >
                                                        {showAllJobTypes ? 'Show Less' : 'Show More'}
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {/* Contract Status Filter */}
                                <div className="mb-4 filter-section">
                                    <div
                                        className="d-flex justify-content-between align-items-center cursor-pointer mb-2 filter-header"
                                        onClick={() => setShowContractStatus(!showContractStatus)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <strong>Contract Status</strong>
                                        <i className={`bi ${showContractStatus ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showContractStatus && (
                                        <div className="filter-content">
                                            <div className="d-flex flex-column gap-2">
                                                {contractStatuses.slice(0, showAllContractStatuses ? contractStatuses.length : 5).map((status) => (
                                                    <div key={status.id} className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            id={`status-${status.id}`}
                                                            checked={activeFilters.contractStatus.includes(status.id)}
                                                            onChange={() => toggleFilter('contractStatus', status.id)}
                                                        />
                                                        <label className="form-check-label" htmlFor={`status-${status.id}`}>
                                                            {status.name}
                                                        </label>
                                                    </div>
                                                ))}
                                                {contractStatuses.length > 5 && (
                                                    <button
                                                        className="btn btn-link p-0 text-decoration-none text-primary" style={{ textAlign: 'left' }}
                                                        onClick={() => setShowAllContractStatuses(!showAllContractStatuses)}
                                                    >
                                                        {showAllContractStatuses ? 'Show Less' : 'Show More'}
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {/* Post By Filter */}
                                <div className="mb-4 filter-section">
                                    <div
                                        className="d-flex justify-content-between align-items-center cursor-pointer mb-2 filter-header"
                                        onClick={() => setShowPostBy(!showPostBy)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <strong>Post By</strong>
                                        <i className={`bi ${showPostBy ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showPostBy && (
                                        <div className="filter-content">
                                            <div className="d-flex flex-column gap-2">
                                                {postByOptions.map((option) => (
                                                    <div key={option.id} className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="postBy"
                                                            id={`postby-${option.id}`}
                                                            checked={activeFilters.postBy === option.id}
                                                            onChange={() => toggleRadioFilter('postBy', option.id)}
                                                        />
                                                        <label className="form-check-label" htmlFor={`postby-${option.id}`}>
                                                            {option.name}
                                                        </label>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {/* Language Filter */}
                                <div className="mb-4 filter-section">
                                    <div
                                        className="d-flex justify-content-between align-items-center cursor-pointer mb-2 filter-header"
                                        onClick={() => setShowLanguage(!showLanguage)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <strong>Language</strong>
                                        <i className={`bi ${showLanguage ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showLanguage && (
                                        <div className="filter-content">
                                            <div className="d-flex flex-column gap-2">
                                                {languages.slice(0, showAllLanguages ? languages.length : 5).map((lang) => (
                                                    <div key={lang.id} className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            id={`lang-${lang.id}`}
                                                            checked={activeFilters.language.includes(lang.id)}
                                                            onChange={() => toggleFilter('language', lang.id)}
                                                        />
                                                        <label className="form-check-label" htmlFor={`lang-${lang.id}`}>
                                                            {lang.name}
                                                        </label>
                                                    </div>
                                                ))}
                                                {languages.length > 5 && (
                                                    <button
                                                        className="btn btn-link p-0 text-decoration-none text-primary" style={{ textAlign: 'left' }}
                                                        onClick={() => setShowAllLanguages(!showAllLanguages)}
                                                    >
                                                        {showAllLanguages ? 'Show Less' : 'Show More'}
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {/* Main Skills Filter */}
                                <div className="mb-4 filter-section">
                                    <div
                                        className="d-flex justify-content-between align-items-center cursor-pointer mb-2 filter-header"
                                        onClick={() => setShowSkills(!showSkills)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <strong>Main Skills</strong>
                                        <i className={`bi ${showSkills ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showSkills && (
                                        <div className="filter-content">
                                            <div className="d-flex flex-column gap-2">
                                                {mainSkills.slice(0, showAllSkills ? mainSkills.length : 5).map((skill) => (
                                                    <div key={skill.id} className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            id={`skill-${skill.id}`}
                                                            checked={activeFilters.skills.includes(skill.id)}
                                                            onChange={() => toggleFilter('skills', skill.id)}
                                                        />
                                                        <label className="form-check-label" htmlFor={`skill-${skill.id}`}>
                                                            {skill.name}
                                                        </label>
                                                    </div>
                                                ))}
                                                {mainSkills.length > 5 && (
                                                    <button
                                                        className="btn btn-link p-0 text-decoration-none text-primary" style={{ textAlign: 'left' }}
                                                        onClick={() => setShowAllSkills(!showAllSkills)}
                                                    >
                                                        {showAllSkills ? 'Show Less' : 'Show More'}
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>

                    {/* Job Listings */}
                    <div className="col-md-9">
                        {filteredJobs.length === 0 ? (
                            <div className="text-center no-jobs-message">No applied jobs match your filters</div>
                        ) : (
                            <div className="row">
                                {filteredJobs.map((job) => {
                                    const status = jobApplicationStatus[job.id] || 'Applied';
                                    const badgeClass = getStatusBadgeStyle(status);

                                    return (
                                        <div key={job.id} className="col-md-12 mb-4">
                                            <div
                                                className="jobcard-wrapper-employee applied-jobs-card d-flex p-3 shadow-sm rounded position-relative"
                                                onClick={() => handleJobClick(job)}
                                                style={{ cursor: 'pointer' }}
                                            >
                                                {/* Status badge at top right */}
                                                <span className={`position-absolute top-0 end-0 badge bg-${badgeClass}-applied m-2`}>
                                                    {status}
                                                </span>

                                                {/* Enlarged Image Section */}
                                                <div className="jobcard-image text-center" style={{ width: '18%', flexShrink: 0 }}>
                                                    <img
                                                        src={job.profile_photo_url || '/fallback-user.png'}
                                                        alt={job.job_title}
                                                        className="img-fluid rounded-circle jobcard-avatar mb-2"
                                                        style={{ width: '110px', height: '105px', objectFit: 'cover' }}
                                                    />
                                                    <div className={`jobcard-label ${job.posted_by?.toLowerCase().includes('direct') ? 'label-direct' : 'label-agency'}`}>
                                                        {job.posted_by?.toLowerCase().includes('direct') ? 'Direct' : 'Agency'}
                                                    </div>
                                                </div>

                                                {/* Shrunk Text Section */}
                                                <div className="jobcard-content ms-3" style={{ width: '70%' }}>
                                                    <h5 className="jobcard-title">{job.job_title || 'No title'}</h5>
                                                    <div className="jobcard-family text-muted mb-1">
                                                        {job.adults || 'N/A'} adults + {job.children || 'N/A'} kids | {job.nationality || 'N/A'}
                                                    </div>
                                                    <div className="jobcard-location text-muted mb-2">
                                                        <i className="bi bi-geo-alt-fill me-1"></i>
                                                        {job.working_city || 'N/A'}, {job.state_or_province || 'N/A'}
                                                    </div>
                                                    <div
                                                        className="jobcard-description text-muted mb-1"
                                                        style={{
                                                            display: '-webkit-box',
                                                            WebkitLineClamp: 2,
                                                            WebkitBoxOrient: 'vertical',
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis'
                                                        }}
                                                    >
                                                        {job.job_description || 'No description available'}
                                                    </div>
                                                    <div className="d-flex flex-wrap gap-3 small mt-1">
                                                        <div className="text-muted">
                                                            <i className="bi bi-person-fill me-1"></i>
                                                            {job.domestic_worker_category || 'N/A'} | {job.job_type || 'N/A'}
                                                        </div>
                                                        <div className="text-muted">
                                                            <i className="bi bi-calendar-event me-1"></i>
                                                            {formatDate(job.job_starting_date)}
                                                        </div>
                                                        <div className="text-success fw-semibold">
                                                            <i className="bi bi-circle-fill me-1"></i>
                                                            Very Active
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    );
                                })}
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
}

export default AppliedJobs;